import React from 'react'
import { Helmet } from "react-helmet"
import cx from 'classnames'

import "typeface-source-sans-pro"

import Header from '../components/IndexPage/Header'
import Footer from '../components/IndexPage/Footer'
import SEO from "../components/seo"

import Styles from '../styles/main.module.css'


class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
    }
  }

  componentDidMount() {
    this.timeoutId = setTimeout(() => {
      this.setState({ loading: false });
    }, 500);
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }

  render() {

    let loadings = this.state.loading;

    return (
      <React.Fragment>
        <SEO title="Main" />
        {/* Belajar Website dari 0. Web Development Roadmap 2020. HTML, CSS, Javascript dan semua tentang web development */}
        <Helmet>
          <html className={Styles.html} lang="id" />
          <body className={loadings ? cx(Styles.isPreload, Styles.body) : Styles.body} />
        </Helmet>

        <div id="wrapper" className={cx(Styles.asterisk, Styles.wrapper)}>
          <Header />
          <Footer />
        </div>
        <div id="bg" className={cx(Styles.asterisk, Styles.bg)}></div>
      </React.Fragment>
    )
  }
}

export default IndexPage